import { __awaiter } from "tslib";
import { jsx as _jsx } from "preact/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { getArticleId } from './helpers/getIds';
import { WikiRecommendationsProvider } from './helpers/WikiRecommendationsContext';
import { RecommendationsBox } from './components/RecommendationsBox';
const MIN_RECOMMENDATIONS_COUNT = 5;
export const OnWikiRecommendationsModule = ({ track, config, isRightRail = false }) => {
    const { wikiId, pageId } = getArticleId();
    const [renderTracked, setRenderTracked] = useState(false);
    const [recommendations, setRecommendations] = React.useState(null);
    const wrapperRef = React.createRef();
    const getRecommendations = () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield fetch(`https://services.fandom.com/recommendations/recommendations?wikiId=${wikiId}&articleId=${pageId}`);
        const json = (yield response.json());
        return json.article_recommendation.filter(({ item_id }) => {
            const recommendationWikiId = item_id.split('_')[0];
            return recommendationWikiId === wikiId;
        });
    });
    React.useEffect(() => {
        let subscribed = true;
        Promise.all([getRecommendations()]).then(([res]) => {
            if (subscribed) {
                setRecommendations(res);
            }
        });
        return () => {
            subscribed = false;
        };
    }, []);
    useEffect(() => {
        if (wrapperRef.current !== null && !renderTracked) {
            setRenderTracked(true);
            track({ action: 'rendered' });
        }
    }, [wrapperRef]);
    return (_jsx(WikiRecommendationsProvider, Object.assign({ value: {
            recommendations,
            track,
            wikiId,
            variant: config.variant,
            isRightRail,
        } }, { children: (recommendations === null || recommendations === void 0 ? void 0 : recommendations.length) >= MIN_RECOMMENDATIONS_COUNT && (_jsx("div", Object.assign({ ref: wrapperRef }, { children: _jsx(RecommendationsBox, {}, void 0) }), void 0)) }), void 0));
};
